import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=61a7311e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=61a7311e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a7311e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a7311e')) {
      api.createRecord('61a7311e', component.options)
    } else {
      api.reload('61a7311e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=61a7311e&scoped=true&", function () {
      api.rerender('61a7311e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k6AepnnsWrY6/JS/teamMember.vue"
export default component.exports